export const OPEN = 'MODAL.OPEN';
export const CLOSE = 'MODAL.CLOSE';


// WEBPACK FOOTER //
// ./src/constants/Modal.ts